import { useLocation } from 'react-router-dom';

export function useIsButtonLinkActive() {
  const pathname = useLocation().pathname;

  return (to: string) => pathname.split('/').includes(to);
}
